import classNames from "classnames";
import styles from "./AscReminderCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";

import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";
import AscSelectInput from "../../AscInputFields/AscSelectInput/AscSelectInput";
import { Bullpen } from "@ascendnow/shared";
import * as Yup from "yup";
import {
  formatErrorMessage,
  useAscContext,
} from "@ascendnow/ascend-components";
import AscButton from "../../AscButton/AscButton";
import { useFormik } from "formik";
export interface AscFiltersCardProps {
  className?: string;
  bullpens: Bullpen[];
  countries: any;
  applyReminderFormApi: any;
}

export default function AscReminderCard({
  className,
  bullpens,
  countries,
  applyReminderFormApi,
}: AscFiltersCardProps) {
  const { toast } = useAscContext();

  const formik = useFormik({
    initialValues: {
      name: "",
      age: "",
      school: "",
      country: "",
      eventId: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      age: Yup.string().required("Age is required"),
      school: Yup.string().required("School is required"),
      country: Yup.string().required("Country is required"),
      eventId: Yup.string().required("Event is required"),
    }),
    onSubmit: async (values, actions) => {
      try {
        const age = parseInt(values.age, 10);
        if (isNaN(age)) {
          throw new Error("Age must be a number.");
        }
        await applyReminderFormApi({ ...values, age });
        toast.success("Form submitted successfully!");
        actions.resetForm({
          values: {
            name: "",
            age: "",
            school: "",
            country: "",
            eventId: "",
          },
        });
      } catch (error) {
        toast?.error(
          formatErrorMessage(error, "An error occurred while submitting!")
        );
      }
    },
  });

  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      title={null}
      coverImageUrl={null}
    >
      <AscParagraph className={styles.title}>
        Send me a reminder for the next competition
      </AscParagraph>
      <form className={styles.content} onSubmit={formik.handleSubmit}>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Name</AscParagraph>
          <AscTextInput
            id="name"
            name="name"
            onChange={formik.handleChange}
            value={formik.values.name}
            onBlur={formik.handleBlur}
            placeholder="Philipa Yaltis..."
          />
          {formik.touched.name && formik.errors.name && (
            <div className={styles.error}>{formik.errors.name}</div>
          )}
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Age</AscParagraph>
          <AscTextInput
            id="age"
            name="age"
            onChange={formik.handleChange}
            value={formik.values.age}
            onBlur={formik.handleBlur}
            placeholder="12"
          />
          {formik.touched.age && formik.errors.age && (
            <div className={styles.error}>{formik.errors.age}</div>
          )}
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>School</AscParagraph>
          <AscTextInput
            id="school"
            name="school"
            onChange={formik.handleChange}
            value={formik.values.school}
            onBlur={formik.handleBlur}
            placeholder="Name of school"
          />
          {formik.touched.school && formik.errors.school && (
            <div className={styles.error}>{formik.errors.school}</div>
          )}
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Country</AscParagraph>
          <AscSelectInput
            onBlur={formik.handleBlur}
            onChange={(val) => formik.setFieldValue("country", val)}
            value={formik.values.country}
            name="country"
            id="country"
            placeholder="Select country"
            className={styles.countryInput}
          >
            {countries?.map((option: any) => (
              <AscSelectInput.Option
                key={option.id}
                value={option.name}
                label={option.name}
              />
            ))}
            {formik.touched.country && formik.errors.country && (
              <div className={styles.error}>{formik.errors.country}</div>
            )}
          </AscSelectInput>
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Event</AscParagraph>
          <AscSelectInput
            id="eventId"
            name="eventId"
            onChange={(val) => formik.setFieldValue("eventId", val)}
            value={formik.values.eventId}
            placeholder="Name of event"
          >
            {bullpens?.map((option) => (
              <AscSelectInput.Option
                key={option.id}
                value={option.id}
                label={option.name}
              />
            ))}
          </AscSelectInput>
          {formik.touched.eventId && formik.errors.eventId && (
            <div className={styles.error}>{formik.errors.eventId}</div>
          )}
        </div>
        <AscButton disabled={!formik.isValid} type="submit">
          Apply
        </AscButton>
      </form>
    </AscGenericCard>
  );
}
